module.exports = __webpack_public_path__ + "static/img/2019.fcada75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2019.png
// module id = Mtft
// module chunks = 1